<template>
  <el-drawer
    :title="title"
    :visible.sync="visibleFlag"
    :direction="direction"
    :custom-class="customClass"
    :size="size"
    :wrapper-closable="wrapperClosable"
    :append-to-body="appendToBody"
    :modal-append-to-body="modalAppendToBody"
    :modal="hasModal"
    @close="close"
    @closed="closed"
    @open="open"
    @opened="opened"
  >
    <template #title>
      <slot name="title"></slot>
    </template>
    <slot></slot>
    <div v-if="isShowFooter" class="drawer__footer">
      <slot name="footer">
        <span class="drawer__footer-left"><slot name="footerRight"></slot></span>
        <span class="drawer__footer-right">
          <slot name="beforBtnRight"></slot>
          <el-button v-if="otherBtn1" @click="handleOtherBtn1">{{ otherBtn1 }}</el-button>
          <el-button v-if="showCancelButton" class="cancle-btn" @click="visibleFlag = false">{{ cancelBtn }}</el-button>
          <el-button v-if="otherBtn" :loading="otherBtnLoading" class="cancle-btn" @click="handleOtherBtn">{{ otherBtnLoading ? `${loadingText} ...` : otherBtn }}</el-button>
          <slot name="otherBtn2"></slot>
          <el-button v-if="showConfirmButton" type="primary" :disabled="disableCfmBtn" :loading="loading" @click="handleDialogConfirm">
            {{ loading ? `${loadingText} ...` : confirmBtn }}
          </el-button>
        </span>
      </slot>
    </div>
  </el-drawer>
</template>

<script>
import i18n from '@/lang';

export default {
  name: 'Drwaer',
  props: {
    blue: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    disableCfmBtn: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String || Number,
      default: '40%'
    },
    customClass: {
      type: String,
      default: ''
    },
    hasModal: {
      type: Boolean,
      default: true
    },
    otherBtnLoading: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'rtl'
    },
    otherBtn: {
      type: String,
      default: ''
    },
    otherBtn1: {
      type: String,
      default: ''
    },
    cancelBtn: {
      type: String,
      default: i18n.t('取 消')
    },
    confirmBtn: {
      type: String,
      default: i18n.t('确 定')
    },
    wrapperClosable: {
      type: Boolean,
      default: false
    },
    isShowFooter: {
      type: Boolean,
      default: true
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    isNewColour: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: i18n.t('提交中')
    }
  },
  data() {
    return {
      visibleFlag: false
    };
  },
  watch: {
    visible() {
      this.visibleFlag = this.visible;
    }
  },
  mounted() {
    window.addEventListener('keydown', e => {
      if (e.keyCode === 27) {
        this.visibleFlag = false;
      }
    });
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    handleOtherBtn() {
      this.$emit('otherBtn');
    },
    handleOtherBtn1() {
      this.$emit('otherBtn1');
    },
    handleDialogConfirm() {
      this.$emit('confirm');
    },
    closed() {
      this.$emit('closed');
    },
    open() {
      this.$emit('open');
    },
    opened() {
      this.$emit('opened');
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-drawer__header {
  font-size: 16px;
  color: #000;
  border-bottom: 1px solid #f0f0f0;
  padding: 20px;
  margin: 0;
}
::v-deep .el-drawer__body {
  overflow: auto;
  padding: 24px;
  margin-bottom: 50px;
}
::v-deep .drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-top: 1px solid #e9e9e9;
  background: #fff;
  display: flex;
  align-items: center;
  z-index: 10;
  justify-content: space-between;
  padding: 0 6px 0 16px;
  &-right {
    display: flex;
    align-items: center;
    .el-button {
      margin: 0 !important;
      &:not(:last-of-type) {
        margin-right: 10px !important;
      }
    }
  }
}
</style>
